import { ICustomersState } from 'redux/reducers/customers';

export const getDisplayName = (
  name: string,
  customers: ICustomersState
): string => {
  if (!customers.fulfilled) {
    return name;
  }
  const customer = customers.data.find((c: any) => c.name === name);
  return customer ? customer.displayName : name;
};
